export default "__VITE_ASSET__D6TBoub0__"